import axios from 'axios'

export const AdminAuditLogService = {
  fetchAuditLogList (queryParams) {
    if (queryParams) {
      return axios.get(`/api/v1/auditloglist${queryParams}`)
    } else {
      return axios.get(`/api/v1/auditloglist`)
    }
  },
  fetchAuditFilterslList () {
    return axios.get(`/api/v1/auditlogfilterparams`)
  },
  fetchAdoptionAcivityLogForDashbrd () {
    return axios.get(`/api/v1/adoptionactivitylog`)
  }
}
